import http from './httpRequest'

export function getOrganization() {
  return http({
    url: '/organization/get',
    method: 'get'
  })
}

export function saveOrganization(canvasData, version) {
  return http({
    url: '/organization/save',
    method: 'post',
    data: { canvasData, version }
  })
}

export function checkOrganizationUpdate(version) {
  return http({
    url: '/organization/check-update',
    method: 'get',
    params: { version }
  })
}
